export enum EventBusMessages {
    SHOW_ERROR = 'SHOW_ERROR',
    SHOW_SUCCESS = 'SHOW_SUCCESS',
    SHOW_INFO = 'SHOW_INFO',
    SHOW_LOADER = 'SHOW_LOADER',
    HIDE_LOADER = 'HIDE_LOADER',
}
